import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useRosterInfo } from "@/hooks";
import { selectWeeklyPlanData } from "@/store/slices";
import { AsyncLoadingState } from "@/features/dashboard/enums";
import { WeeklyPlanStateData } from "@/models";
import { AssignmentStatus } from "@/enums";
import moment from "moment";

export type ReferencePlanState = {data: WeeklyPlanStateData};

export const useReferencePlan = (): ReferencePlanState => {
  //The rollover workflow should be accessible starting on the last day of the school week ("Friday") at noon, and be available to complete, if the user has not already completed it, until the end of the day on the first day of the next school week ("Monday") at 11:59 PM
  // ^ ^ ^ time needs to be implemented in usePlannerCompare since it was a late requirement; usePlannerCompare should also be used in the RolloverSteps component to determine if the rollover workflow is available

  // Weekly plan slice always gets data for the "current week" (Monday to Friday); 
  // Saturdays and Sundays are also treated as if they're in the "current week" by the plan (USER LOCALE DEPENDENT? SERVER DEPENDENT?)
  // During the rollover period(as determined by usePlannerCompare) FRI-SUN, the reference plan should be the current weekly plan
  // During the rollover period MON, the reference plan should be "last week's" weekly plan(this also seems like a new and potentially difficult requirement!)
  const refPlanFrom = useMemo(() => {
    const today = moment();
    const dayOfWeek = today.isoWeekday(); // 1 = Monday, 7 = Sunday
    const retvalue = dayOfWeek === 1 ? moment().startOf("isoWeek").subtract(1, "week").toDate() : moment().startOf("isoWeek").toDate();
    console.log("=== Reference plan from ===> ", retvalue);
    return retvalue;
  }, []);

  //need to define refPlanData, could be line 30 OR the reconstruction of an older plan from last week for Mondays
  const [refPlanData, setRefPlanData] = useState<any>(null);
  const { assignments, dateFrom, dateTo, curTrack } = useSelector(selectWeeklyPlanData); // get assignments from the weekly plan data -  depending on the day, we can't get this from the weekly plan data; need to re-run aggregateAssignmentsToLessons(?) over for a different date
  const { students } = useRosterInfo();

  const lastWeekAssignments = useMemo(() => {
    if (!assignments || !dateFrom || !dateTo ) return [];
    const refAssignments = structuredClone(assignments);
    // //  const refAssignments = structuredClone(assignments).slice(0,5);
    // refAssignments.forEach((a) => {
    //       const updatedDate = new Date(dateFrom as Date);
    //       updatedDate.setDate(updatedDate.getDate() + 2);
    //       a.dateFrom = updatedDate.toISOString();
    //       a.status = AssignmentStatus.IN_PROGRESS;
    //     });
    // console.log("----=====> reference plan assignments", refAssignments);

    return refAssignments.filter(({ dateFrom: assignmentDateFrom }) => {
      const assignmentDate = new Date(assignmentDateFrom);
      const planDateFrom = new Date(dateFrom);
      const planDateTo = new Date(dateTo);
      return assignmentDate >= planDateFrom && assignmentDate < planDateTo;
    });
  }, [assignments, dateFrom, dateTo]);

  // We have to collect an entirely separate set of mastery data for the reference plan
  const mastery = useMemo(() => {
    if (!lastWeekAssignments || !students) return {};

    //console.log("=== Last week assignments ===> ", lastWeekAssignments);

    // Gather all the focus skill Ids from the last week assignments
    const manifestSkills = lastWeekAssignments.reduce((acc, assignment) => {
      if (Array.isArray(assignment.manifest)) {
        assignment.manifest.forEach((manifestItem) => {
          if (Array.isArray(manifestItem.skills)) {
            manifestItem.skills.forEach((skill) => {
              if (skill.skillId && !acc.includes(skill.skillId)) {
                acc.push(skill.skillId);
              }
            });
          }
        });
      }
      return acc;
    }, [] as string[]);

    // Fetch mastery for all students for the focus skill Ids

/* 
    capture mastery flags for each student
      no_data → red
      red → red
      yellow → yellow
      yellow → red
      green → yellow
      green → red

    Specific exclusions:
      red → yellow
      no_data → yellow
      yellow → green
*/

    // search through mastery records for each student

    // capture flagged mastery records and track in a state

    // Return the mastery data

    return {};
  }, [ lastWeekAssignments, students ]);

  return {
    data: {
      assignments: lastWeekAssignments,
      curriculum: {
        name: "",
        id: "",
        dateTo: "",
        dateFrom: "",
        tracks: []
      },
      curTrack,
      dateFrom: dateFrom,
      dateTo: dateTo,
      studentAssignmentInfo: [],
      curriculumInfo: [],
      stories: {},
      resources: [],
      resourcesFetchQueue: [],
      masteryFetchQueue: [],
      crudAssignmentQueue: [],
      crudResponseByLessonPlanId: [],
      searchedStories: [],
      fetchSkillResourcesLoading: 0,
      mutateAssignmentsLoading: AsyncLoadingState.NONE,
      // Proxied values from the weekly plan data
      students,
      mastery,
    }
  }
}